import React, { useState } from 'react';
import {
    Button,
    FormControl,
    FormLabel,
    Icon,
    Textarea,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
} from '@chakra-ui/react'
import { VscAdd } from 'react-icons/vsc';
import { useDispatch } from 'react-redux';
import { createServicio, getServicios } from '../../features/serviciosSlice';

export const ModalAgregarServicios = ({ page, perPage }) => {
    const dispatch = useDispatch();

    const [isModalOpen, setIsModalOpen] = useState(false);

    const initialValues = {
        descripcion: ''
    }

    const [indice, setIndice] = useState(initialValues);

    const handleModalOpen = () => {
        setIsModalOpen(!isModalOpen)
    }

    const handleModalClose = () => {
        setIsModalOpen(false)
        setIndice(initialValues)
    }

    const handleSave = () => {
        dispatch(createServicio(indice)).then(() =>{
            dispatch(getServicios({ page, perPage })); // Usa los valores pasados como props y Actualiza 
            setIsModalOpen(false)
            setIndice(initialValues)
        });
       
    }


    return (
        <>
            <Button
                colorScheme="blue"
                _dark={{ bg: "blue.500", color: "white", _hover: { bg: "blue.600" }}}
                aria-label="Agregar"
                leftIcon={<Icon as={VscAdd} fontSize="lg" />}
                variant="solid"
                rounded={'xl'}
                onClick={handleModalOpen}
            >
                Nuevo Registro
            </Button>
            <Modal isOpen={isModalOpen} onClose={handleModalClose} size="5xl" isCentered>
                <ModalOverlay 
                    bg="rgba(11,15,25, 0.8)"
                    backdropFilter='auto'
                    backdropBlur='2px'
                />
                <ModalContent _dark={{ bg: "primary.1000" }} borderRadius="2xl">
                    <ModalHeader textAlign="center">AGREGAR NUEVO SERVCIO</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Stack spacing={4} direction={{ base: "column", lg: "row"}} justifyContent="space-between" p={4}>
                                <FormControl>
                                    <FormLabel>DESCRIPCIÓN</FormLabel>
                                    <Textarea
                                        placeholder="Escribe la descripcion del servicio"
                                        type="text"
                                        onChange={(e) => setIndice({ ...indice, descripcion: e.target.value })}
                                    />
                                </FormControl>
                        </Stack>
                    
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="red" _dark={{ bg: "red.500", color: "white", _hover: { bg: "red.600" } }} size="lg" mr={3} onClick={handleModalClose} borderRadius="xl">
                            CANCELAR
                        </Button>
                        <Button
                            colorScheme="blue"
                            _dark={{ bg: "blue.500", color: "white", _hover: { bg: "blue.600" } }}
                            size="lg"
                            mr={3}
                            onClick={handleSave}
                            borderRadius="xl"
                            disabled={indice.descripcion === ''}
                        >
                            GUARDAR
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}
